import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { status } from 'constants/general';
import { registerFormStepsEnum, registerFormTitleToStepMapEnum } from 'modules/general/enums';
import generalStrings from 'modules/general/strings';
import ProgressBar from 'modules/common/components/ProgressBar';
import SectionDivider from 'modules/common/components/SectionDivider';
import Loader from 'modules/common/components/Loader';

import BusinessIndustry from './RegisterFormSubComponents/BusinessIndustry';
import CompanyInformation from './RegisterFormSubComponents/CompanyInformation';
import UserPosition from './RegisterFormSubComponents/UserPosition';
import AccountInformation from './RegisterFormSubComponents/AccountInformation';

import {
  FormWrapper,
  FormTitle,
  FormSubTitle,
  FormBtnWrapper,
  FormNextBtn,
  FormBackBtn,
} from './RegisterForm.style';

const RegisterForm = ({
  currentStep,
  formFieldsValues,
  formFieldsValidation,
  handleTextInputFieldChange,
  handleDropdownFieldChange,
  handleRadioBtnFieldChange,
  handleNextBtnClick,
  handleBackBtnClick,
}) => {
  const { registerFormSubmission } = useSelector(state => ({
    registerFormSubmission: state.general.registerFormSubmission,
  }));

  const renderFormStep = () => (
    <>
      {currentStep === registerFormStepsEnum.businessIndustry && (
        <BusinessIndustry
          formFieldsValues={formFieldsValues}
          formFieldsValidation={formFieldsValidation}
          handleTextInputFieldChange={handleTextInputFieldChange}
          handleRadioBtnFieldChange={handleRadioBtnFieldChange}
        />
      )}
      {currentStep === registerFormStepsEnum.companyInformation && (
        <CompanyInformation
          formFieldsValues={formFieldsValues}
          formFieldsValidation={formFieldsValidation}
          handleTextInputFieldChange={handleTextInputFieldChange}
          handleDropdownFieldChange={handleDropdownFieldChange}
        />
      )}
      {currentStep === registerFormStepsEnum.userPosition && (
        <UserPosition
          formFieldsValues={formFieldsValues}
          formFieldsValidation={formFieldsValidation}
          handleTextInputFieldChange={handleTextInputFieldChange}
          handleRadioBtnFieldChange={handleRadioBtnFieldChange}
        />
      )}
      {currentStep === registerFormStepsEnum.accountInformation && (
        <AccountInformation
          formFieldsValues={formFieldsValues}
          formFieldsValidation={formFieldsValidation}
          handleTextInputFieldChange={handleTextInputFieldChange}
        />
      )}
    </>
  );

  const renderNextBtnText = () => {
    if (registerFormSubmission.status === status.FETCHING)
      return <Loader width={14} height={14} thickness={4} />;

    if (currentStep === registerFormStepsEnum.accountInformation)
      return generalStrings.registerForm.createAccountBtnText;

    return generalStrings.registerForm.nextBtnText;
  };

  return (
    <FormWrapper>
      <FormTitle>{registerFormTitleToStepMapEnum[currentStep]}</FormTitle>
      {false && (
        <>
          <SectionDivider gap={4} />
          <FormSubTitle>{generalStrings.registerForm.subTitle}</FormSubTitle>
        </>
      )}
      <SectionDivider gap={24} />
      <ProgressBar width={Math.min(currentStep * 25, 100)} />
      <SectionDivider gap={24} />
      {renderFormStep()}
      <SectionDivider gap={99} />
      <FormBtnWrapper>
        {currentStep !== registerFormStepsEnum.businessIndustry && (
          <FormBackBtn as="button" onClick={handleBackBtnClick}>
            {generalStrings.registerForm.backBtnText}
          </FormBackBtn>
        )}
        <FormNextBtn as="button" onClick={handleNextBtnClick}>
          {renderNextBtnText()}
        </FormNextBtn>
      </FormBtnWrapper>
    </FormWrapper>
  );
};

RegisterForm.propTypes = {
  currentStep: PropTypes.number.isRequired,
  formFieldsValues: PropTypes.shape().isRequired,
  formFieldsValidation: PropTypes.shape().isRequired,
  handleTextInputFieldChange: PropTypes.func.isRequired,
  handleDropdownFieldChange: PropTypes.func.isRequired,
  handleRadioBtnFieldChange: PropTypes.func.isRequired,
  handleNextBtnClick: PropTypes.func.isRequired,
  handleBackBtnClick: PropTypes.func.isRequired,
};

export default RegisterForm;
